export default "__VITE_ASSET__Dnzp9bqx__"